export const DEFAULT_CHART_OPTIONS = {
  responsive: true,
  locale: 'en',
  maintainAspectRatio: false,
  animation: {
    duration: 300,
  },
  animations: {
    x: {
      duration: 0,
    },
    barPercentage: {
      duration: 0,
    },
    categoryPercentage: {
      duration: 0,
    },
  },
  datasets: {
    bar: {
      // Needed to be false in v4.5.0. Don't upgrade to v4.5.0 until a solution is found for this issue: https://github.com/chartjs/Chart.js/pull/12070
      grouped: true,
    },
  },
}
